export const INIT_CUSTOMER = "INIT_CUSTOMER";
export const FETCH_CUSTOMER_LIST_START = "FETCH_CUSTOMER_LIST_START";
export const FETCH_CUSTOMER_LIST_SUCCESS = "FETCH_CUSTOMER_LIST_SUCCESS";
export const FETCH_CUSTOMER_LIST_ERROR = "FETCH_CUSTOMER_LIST_ERROR";

export const EDIT_CUSTOMER_RECORD = {
  START: "EDIT_CUSTOMER_RECORD_START",
  SUCCESS: "EDIT_CUSTOMER_RECORD_SUCCESS",
  ERROR: "EDIT_CUSTOMER_RECORD_ERROR",
};

export const FETCH_CUSTOMER_DETAIL = {
  START: "FETCH_CUSTOMER_DETAIL_START",
  SUCCESS: "FETCH_CUSTOMER_DETAIL_SUCCESS",
  ERROR: "FETCH_CUSTOMER_DETAIL_ERROR",
};

export const TOAST = {
  RESET: "RESET_TOAST",
};

export const CUSTOMER_CURRENCIES_PROVIDER_DD = {
  START: "CUSTOMER_CURRENCIES_PROVIDER_DD_START",
  SUCCESS: "CUSTOMER_CURRENCIES_PROVIDER_DD_SUCCESS",
  ERROR: "CUSTOMER_CURRENCIES_PROVIDER_DD_ERROR",
};

export const CUSTOMER_COUNTRIES_PROVIDER_DD = {
  START: "CUSTOMER_COUNTRIES_PROVIDER_DD_START",
  SUCCESS: "CUSTOMER_COUNTRIES_PROVIDER_DD_SUCCESS",
  ERROR: "CUSTOMER_COUNTRIES_PROVIDER_DD_ERROR",
};

export const DROPDOWN_TYPES = {
  TAX_TYPE: {
    START: "FETCH_TAX_TYPE_START",
    SUCCESS: "FETCH_TAX_TYPE_SUCCESS",
    ERROR: "FETCH_TAX_TYPE_ERROR",
  },
  REVENUE_TYPE: {
    START: "FETCH_REVENUE_TYPE_START",
    SUCCESS: "FETCH_REVENUE_TYPE_SUCCESS",
    ERROR: "FETCH_REVENUE_TYPE_ERROR",
  },
};
